<template>
  <card titulo="Indisponibilidades" classTitle="active">
    <template #acoes>
      <a v-if="!$root.isAuditorOnly" @click="consultarCnib()" title="Consultar CNIB" class="icon float-right pointer mr-3">
        <i class="fal fa-search"></i>
      </a>
    </template>

    <consulta :columns="columns" ref="tabela" :process="process" classe="tbl-consulta"
              label-lista-vazia="Não há indisponibilidades para exibir">

      <template #row="{ row }">

        <tr>
          <td class="text-truncate pr-2">{{row.cnib}}</td>
          <td class="text-truncate pr-2">{{row.nome}}</td>
          <td class="text-truncate pr-2">{{row.documento}}</td>

          <td class="nowrap" width="50px">
            <v-button :run="abrirDetalhes" :params="[row.ordem]" :button="false" class="icon text-secondary" title="Exibir Detalhes">
              <i class="fas fa-home"></i>
            </v-button>
          </td>

        </tr>

      </template>

    </consulta>
  </card>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness.js";
  import CnibPesquisaDocumento from "@/components/Arisp/CnibPesquisaDocumento.vue";
  import DetalhesIndisponibilidade from "@/components/Indisponibilidade/DetalhesIndisponibilidade.vue";
  import Card from "@/components/Layout/components/Card.vue";
  import IndisponibilidadeBusiness from "@/business/IndisponibilidadeBusiness";
  import Consulta from "@/components/Consultas/Consulta.vue";

  export default {

    name: "Indisponibilidades",
    components: {Consulta, Card},
    props: {
      ficha : Object,
    },

    data() {
      return {
        filtros : {
          indicadorRealId: this.ficha.id,
        }
      }
    },

    computed: {
      columns() {
        return [
          {label: 'Protocolo Indisponibilidade', field: 'v.cnib'},
          {label: 'Nome', field: 'v.nome'},
          {label: 'Documento', field: 'v.documento'},
          {label: '', field: null, headerClass: 'column__botao', name: 'botao'}
        ];
      },
    },

    async mounted(){
      await this.$refs?.tabela?.load();
    },

    methods:{
      abrirDetalhes(id) {
        FrontBusiness.openModal(DetalhesIndisponibilidade, {id});
      },

      async process(sort_by, sort_dir, page_length, page_number){
        let result = await IndisponibilidadeBusiness.paginationIndicadorReal(sort_by, sort_dir, page_number, page_length, {filtros: this.filtros});
        return {rows: result.pagina, total: result.quantidade};
      },

      async consultarCnib() {
        await FrontBusiness.openModal(CnibPesquisaDocumento, {indicadorReal: this.ficha.id, consulta: true});
      }

    }
  }
</script>

<style lang=scss>
.tbl-consulta {
  .modal-body {
    padding: 0;
  }
}
</style>
